module.exports = __webpack_public_path__ + "media/images/access_control-6bb01f5a.webp";